// стили темы
import "../scss/style.scss";

// 1) jQuery и moment — в window
import $ from "jquery";
import moment from "moment";
window.$ = $;
window.jQuery = $;
window.moment = moment;

// 2) JS дата-пикера (подцепится как $.fn.daterangepicker)
import "bootstrap-daterangepicker";                 // <-- добавили
import "bootstrap-daterangepicker/daterangepicker.css";

// остальное
import { createPopper } from "@popperjs/core";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

import feather from "feather-icons";
window.feather = feather;

import Chart from "chart.js/auto";
window.Chart = Chart;

import Swiper from "swiper";
window.Swiper = Swiper;

// DataTables (если в коде используется jQuery-инициализация — см. примечание ниже)
import DataTable from "datatables.net";
import "datatables.net-responsive";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
window.DataTable = DataTable;

import dragula from "dragula";
window.dragula = dragula;

import Dropzone from "dropzone";
window.Dropzone = Dropzone;

import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
window.Calendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;

import FroalaEditor from "froala-editor";
window.FroalaEditor = FroalaEditor;

import ProgressBar from "progressbar.js";
window.ProgressBar = ProgressBar;

// SmartWizard — jQuery-плагин
import "smartwizard/dist/css/smart_wizard_all.min.css";
import "smartwizard/dist/js/jquery.smartWizard.min.js";
window.smartWizard = $.fn.smartWizard;

import "simplebar";
import lozad from "lozad";
window.lozad = lozad;

// ваш код
import "./core/functions.js";
import "./core/main.js";
import "./core/responsive.js";
import "./core/color-scheme.js";

// === Ленивый импорт кроппера ТОЛЬКО на странице настроек компании ===
// document.addEventListener('DOMContentLoaded', () => {
//   // 1) вариант по маркеру-модалке
//   const onCompanySettings = document.getElementById('cropperModal');

//   // 2) (альтернатива) по атрибуту <body data-page="company-settings">
//   // const onCompanySettings = document.body?.dataset?.page === 'company-settings';

//   if (onCompanySettings) {
//     import(/* webpackChunkName: "company-settings" */ './pages/company-settings')
//       .then(m => m.initCompanySettingsCropper())
//       .catch(console.error);
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  // const page = document.body?.dataset?.page;

    // Стало: берём с body или любого элемента с data-page
  const pageAttrEl = document.querySelector('[data-page]') || document.body;
  const page = pageAttrEl?.dataset?.page;

  // Только на странице НАСТРОЕК КОМПАНИИ
  if (page === 'company-settings' || document.querySelector('[data-company-cropper]')) {
    import(/* webpackChunkName: "company-settings" */ './pages/company-settings')
      .then(m => m.initCompanySettingsCropper())
      .catch(console.error);
  }

  // Только там, где есть кнопки для медиакроппера (товар/услуга и т.п.)
  if (document.querySelector('[data-universal-cropper], .cropper-trigger')) {
    import(/* webpackChunkName: "universal-cropper" */ './pages/universal-cropper')
      .then(m => m.initUniversalCropper())
      .catch(console.error);
  }

  if (page === 'builder-editor') {
    import(/* webpackChunkName: "builder" */ './builder')
      .then(m => m.initBuilder())
      .catch(console.error);
  }
});
